export class RehospitalisationModel{
    type:string;
    supplierName: any;
    supplier: any ;
    supplierType: any;
    relationNumber: string;
    postalCode: string;
    address1: string;
    address2: string;
    city: string;
    country: string;
    phoneNumber: string;
    email: string;
    fax: string;
    comment: string;
    department: string;
    admissionDate: Date;
    reportAt: string;
    consentingDoctor_ContactPersonName: string;
    consentingDoctor_ContactPersonFunction: string;
    consentingDoctor_ContactPersonPhoneNumber: string;
}